import React from 'react';
import PropTypes from 'prop-types';
import { BaseCard } from '@bvt-shared/component/BaseCard';
import './CardZoning.scss';
import { generateUUID } from '@bvt-utils';

/**
 *
 * @param {object} props
 * @param {Array<string>} props.data
 * @param {import('react').CSSProperties} props.style
 * @param {boolean} props.isLoading
 */

export default function Zoning(props) {
  return (
    <div id={props.id} style={props?.style}>
      <BaseCard isLoading={props?.isLoading} title='Zoning' withPadding={true}>
        <div className='feature-griana Zoning'>
          <div>According to zoning data, this area is territory of</div>
          {props.data?.length ? (
            <div className='feature-griana Zoning--card'>
              {[...(props.data || [])]
                .sort((a, b) => a.length - b.length)
                .map((txt) => (
                  <div className='feature-griana Zoning--item' key={generateUUID()}>
                    {txt}
                  </div>
                ))}
            </div>
          ) : (
            ''
          )}
        </div>
      </BaseCard>
    </div>
  );
}

Zoning.defaultProps = {
  data: [
    'Campuran',
    'Ruang terbuka',
    'Pariwisata',
    'Pemerintahan',
    'Pemukiman',
    'Kawasan lindung',
    'Industri dan perdagangan/jasa',
    'Pelayanan umum',
  ],
};
Zoning.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};
